export function isJpPreBuild(environment = import.meta.env.VITE_DEPLOY_ENV): boolean {
  return environment === 'jp-pre'
}
